import { loop, Cmd } from 'redux-loop';
import { history } from 'store';

const TARGET = 'equality_plan';

const initialState = {
  error: null,
  fetching: false,
  pushing: false,
  data: [],
  item: {},
};

const setEqualityPlanMeasures = (measures) => ({
  type: 'SET_EQUALITY_PLAN_MEASURES',
  measures,
});

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case 'API_CALL_REQUEST':
      if (action.target !== TARGET) return state;
      return {
        ...state,
        fetching: action.method === 'GET',
        pushing: action.method === 'PUT' || action.method === 'POST',
      };
    case 'API_CALL_COMPLETE':
      const { response } = action;
      if (!response || response.target !== TARGET) return state;
      const result = response.result;
      switch(response.method) {
        case 'GET':
          if (Array.isArray(result)) {
            return {
              ...state,
              fetching: false,
              data: result,
            };
          }
          return loop(
            {
              ...state,
              fetching: false,
              item: result,
            },
            Cmd.action(setEqualityPlanMeasures(result.measures))
          );
        case 'POST':
          const newState = {
            ...state,
            pushing: false,
            data: [...state.data, result],
          };
          return loop(
            newState,
            Cmd.run(history.push, { args: [`/equality-plan/${result.id}/`] })
          );
        case 'PUT': {
          const index = state.data.map(
            plan => plan.id
          ).indexOf(parseInt(response.result.id));
          let equalityPlan = response.result;
          const newState = {
            ...state,
            pushing: false,
            data: [
              ...state.data.slice(0, index),
              equalityPlan,
              ...state.data.slice(index + 1)
            ],
            item: equalityPlan,
          };
          return newState;
        }
        case 'DELETE': {
          const index = state.data.map(
            plan => plan.id
          ).indexOf(parseInt(response.result.id));
          return {
            ...state,
            pushing: false,
            data: [
              ...state.data.slice(0, index),
              ...state.data.slice(index + 1)
            ],
          };
        }
        default:
          return state;
      }
    case 'API_CALL_FAILED':
      if(!action.request || action.request.target !== TARGET) return state;
      return {
        ...state,
        fetching: false,
        pushing: false,
        error: action.code,
      };
    default:
      return state;
  }
};

export {
  reducer as equality_plan,
};
